import { computed } from 'vue';
import type { Ref } from 'vue';
import {
  DRAFT_MATRIX_ORDER_OPTIONS,
  MATRIX_MODEL_ORDER_OPTIONS,
  REJECTED_MATRIX_ORDER_OPTIONS,
} from '@/shared/config';
import type { SharedOrderOption } from '@/shared/config';

export interface TabListControls {
  sort: Ref<string>;
  order: Ref<string>;
  isFilterActive: Ref<boolean>;
  urlQuery: Ref<Record<string, string | number>>;
  handleSortUpdate: (sort: string, order: string) => Promise<void>;
  openFilterModal: () => void;
  reset: () => void;
}

interface ActiveListControlsOptions {
  activeSubTab: Ref<string>;
  controlsByTab: Record<string, TabListControls>;
}

const ORDER_OPTIONS_BY_TAB: Record<string, SharedOrderOption[]> = {
  modelos: MATRIX_MODEL_ORDER_OPTIONS,
  rascunhos: DRAFT_MATRIX_ORDER_OPTIONS,
  reprovados: REJECTED_MATRIX_ORDER_OPTIONS,
};

export function useActiveListControls({ activeSubTab, controlsByTab }: ActiveListControlsOptions) {
  const active = computed<TabListControls | undefined>(() => controlsByTab[activeSubTab.value]);

  const orderOptions = computed(
    () => ORDER_OPTIONS_BY_TAB[activeSubTab.value] ?? MATRIX_MODEL_ORDER_OPTIONS
  );

  return {
    orderOptions,
    currentSort: computed(() => active.value?.sort.value),
    currentOrder: computed(() => active.value?.order.value),
    isFilterActive: computed(() => active.value?.isFilterActive.value ?? false),
    urlQuery: computed(() => active.value?.urlQuery.value ?? {}),
    handleSortUpdate: (sort: string, order: string) => active.value?.handleSortUpdate(sort, order),
    openFilterModal: () => active.value?.openFilterModal(),
    resetAll: () => Object.values(controlsByTab).forEach((controls) => controls.reset()),
  };
}
